var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"px-0 py-0 cc-video-viewer",attrs:{"fluid":""}},[_c('div',{staticStyle:{"width":"100%","height":"350px"},attrs:{"id":"video-container"}}),(_vm.name)?_c('p',[_vm._v(_vm._s(_vm.name))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }